import React from 'react';
import './App.css';

import Contact from './sections/Contact';
import Skills from './sections/Skills';
import Introduction from './sections/Introduction';
import Projects from './sections/Projects';
import Background from './sections/Background';
import Experience from './sections/Experience';

function App() {
  return (
    <div className="App">
      <Introduction />
      {/* <Background /> */}
      <Skills />
      <Experience />
      <Projects />
      {/* 
      <section className="section other-projects" data-sr-id="5">
        <div className="section__title">Experience</div>
        <div className="section__content">
          <div className="project">
            <div className="project__name"> <a href="https://archihacks.com/" target="_blank" className="arrow-link">Software
              Developer</a> </div>
            <p>Owned an architectural plugin development for programs used by professional architects.</p>- <div
              className="project__used"> <span className="project__used__item">Python</span> <span
                className="project__used__item">Rhino Commons API</span> </div>
          </div>
          <div className="project">
            <div className="project__name"> <a href="https://bennettoh.github.io/web3d/" target="_blank"
              className="arrow-link">Web3D</a> </div>
            <p>Interactive 3D modeling environment on web browser. It utilizes WebGL with the aid of three.js library.
            Work in progress.</p>- <div className="project__used"> <span className="project__used__item">JavaScript</span> <span
              className="project__used__item">HTML</span> <span className="project__used__item">CSS</span> <span
                className="project__used__item">GitHub Pages</span> <span className="project__used__item">three.js</span> </div>
          </div>
          <div className="project">
            <div className="project__name"> <a href="https://archituts.com/" target="_blank" className="arrow-link">ArchiTuts</a>
            </div>
            <p>Created an online learning platform for architects and students from scratch. Utilized Bootstrap for UI,
            Youtube API for courses, and Firebase for authentication.</p>- <div className="project__used"> <span
              className="project__used__item">HTML, CSS, JS</span> <span className="project__used__item">Bootstrap</span> <span
                className="project__used__item">Firebase authentication</span> <span className="project__used__item">YouTube
              API</span> </div>
          </div>
          <div className="project">
            <div className="project__name"> <a href="https://cawp.sites.olt.ubc.ca/files/2019/08/190724-Advertisement-V2.pdf"
              target="_blank" className="arrow-link">Waterloo Engineering Competition</a> </div>
            <p>Produced and presented the competition winning Smart Campus proposal under intensive constraint on budget
              and time. The proposal detailed clever use of existing infrastructures to quantify and analyze traffic flow
              on the University of Waterloo Campus. Extrapolated data can have immediate application and enormous future
            potentials.<a className="small" href="http://bennettoh.github.io/WEC">🏆 First Place 🏆</a></p>- <div
              className="project__used"> <span className="project__used__item">Computer vision</span> <span
                className="project__used__item">Cloud computing</span> <span className="project__used__item">InDesign</span> <span
                  className="project__used__item">Oral presentation</span> </div>
          </div>
        </div>
      </section>
      <section className="section experience" data-sr-id="3">
        <div className="section__title">Achievements</div>
        <div className="section__content">
          <div className="jobs">
            <div className="job">
              <div className="time-place">
                <div className="job__company"> <a href="https://www.innovationonboard.ca/" target="_blank">Innovation OnBoard
                  - UBC Pitch Competition</a> </div>
                <div className="job__time">2020</div>
              </div>
              <div className="job__position">Semi-finalist avian training system through reinforced learning aided by computer
              vision</div>
            </div>
            <div className="job">
              <div className="time-place">
                <div className="job__company"> <a href="https://yuuvis.com/events/" target="_blank">Yuuvis (Redline)
                  Hackathon</a> </div>
                <div className="job__time">2019</div>
              </div>
              <div className="job__position">Mocked up and demonstrated document translation app in front of industry
              professional judges</div>
            </div>
            <div className="job">
              <div className="time-place">
                <div className="job__company"> <a
                  href="https://www.dezeen.com/2018/08/20/top-15-designs-dezeen-samsung-tv-ambient-mode-competition/"
                  target="_blank">Samsung x Dezeen Ambient Mode Design Competition</a> </div>
                <div className="job__time">2018</div>
              </div>
              <div className="job__position">One of Top 15 proposals exploring creative ways to utlize Samsung's ambient mode
              technology</div>
            </div>
            <div className="job">
              <div className="time-place">
                <div className="job__company"> <a
                  href="https://uwaterloo.ca/co-operative-education/co-op-student-awards/co-op-student-year-awards"
                  target="_blank">Best Co-op Student of the year</a> </div>
                <div className="job__time">2018</div>
              </div>
              <div className="job__position">Received the nomination for making exceptional contribution to work term employer
              during co-op</div>
            </div>
            <div className="job">
              <div className="time-place">
                <div className="job__company"> <a href="https://uwaterloo.ca/systems-design-engineering/deans-honours-list"
                  target="_blank">Dean's Honours List</a> </div>
                <div className="job__time">2017</div>
              </div>
              <div className="job__position">Awarded to top 10% of students of the class based on term GPA</div>
            </div>
            <div className="job">
              <div className="time-place">
                <div className="job__company"> <a
                  href="https://uwaterloo.ca/engineering/entrepreneurship/funding/engineer-future-trust"
                  target="_blank">Engineer of the Future Fund</a> </div>
                <div className="job__time">2017</div>
              </div>
              <div className="job__position">Received $2,500 funding to develop virtual reality design tool for architects and
              engineers</div>
            </div>
            <div className="job">
              <div className="time-place">
                <div className="job__company"> <a
                  href="https://uwaterloo.ca/student-awards-financial-aid/undergraduate-awards/international-experience-awards"
                  target="_blank">Inernational Experience Award</a> </div>
                <div className="job__time">2016</div>
              </div>
              <div className="job__position">Awarded to students to fund international co-op experience</div>
            </div>
            <div className="job">
              <div className="time-place">
                <div className="job__company"> <a href="https://uwaterloo.ca/future-students/financing/scholarships"
                  target="_blank">President's Scholarship</a> </div>
                <div className="job__time">2013</div>
              </div>
              <div className="job__position">Entrance scholarship for students with past outstanding academic achievement
            </div>
            </div>
          </div> <span>Get in touch </span> <span className="emoji pointer"></span> <span> <a
            href="mailto:bennettoh.dev@gmail.com" target="_blank" className="highlight-link">bennettoh.dev@gmail.com</a>
          </span>
        </div>
      </section>
       */}
      <Contact />
    </div>
  );
}

export default App;
